import { UI, HStack, Stack, VStack } from '@genial/components';
import { BoxBorder, Typography } from '@genial/design-tokens';
import { Box } from 'native-base';
import React from 'react';

import { SubscriptionHistoryListItemProps } from '..';
import { HintButton } from '../../../../../../../components/HintButton';
import { TableContentItemStatus } from '../../../../../../../components/TableContent/status';
import { getValidatedStatusIcon } from '../../../../../../../utils/getValidatedStatusIcon';
import { LateralBar } from '../../../../../../BatchTicket/components/DynamicAsset/components/Asset/components/LateralBar';

export const SubscriptionHistoryListItemTablet: React.FC<SubscriptionHistoryListItemProps> = ({
  historyItem,
  isDisabled,
  disabledMessage,
  onCancel,
}) => {
  return (
    <UI.Shadow level={1} borderRadius={BoxBorder.heavy}>
      <Box p="inset.xs" w="full">
        <LateralBar
          backgroundColor="product.rendavariavel"
          borderTopLeftRadius="sm"
          borderBottomLeftRadius="sm"
        />
        <VStack space="stack.xs">
          <HStack justifyContent="space-between">
            <Stack w="1/2">
              <VStack space="stack.quarck">
                <UI.Text variant="semibold" fontSize={Typography['fontsize.xs']}>
                  Cliente
                </UI.Text>
                <UI.Text color="neutral.darkest" variant="semibold">
                  {historyItem.customerNameNormalized}
                </UI.Text>
              </VStack>
            </Stack>
            <Stack w="1/2">
              <VStack space="stack.quarck">
                <UI.Text variant="semibold" fontSize={Typography['fontsize.xs']}>
                  Assessor
                </UI.Text>
                <UI.Text color="neutral.darkest" variant="semibold">
                  {historyItem.advisorNameNormalized}
                </UI.Text>
              </VStack>
            </Stack>
          </HStack>
          <HStack justifyContent="space-between" alignItems="center">
            <Stack w="1/4">
              <VStack space="stack.quarck">
                <UI.Text variant="semibold" fontSize={Typography['fontsize.xs']}>
                  Qtde. Solicitada
                </UI.Text>
                <UI.Text color="neutral.darkest" variant="semibold">
                  {`${historyItem.requestedQuantity}`}
                </UI.Text>
              </VStack>
            </Stack>
            <Stack w="1/4">
              <VStack space="stack.quarck">
                <UI.Text variant="semibold" fontSize={Typography['fontsize.xs']}>
                  Valor
                </UI.Text>
                <UI.Text color="neutral.darkest" variant="semibold">
                  {historyItem.totalValueFormatted}
                </UI.Text>
              </VStack>
            </Stack>
            <Stack w="1/4">
              <VStack space="stack.quarck">
                <UI.Text variant="semibold" fontSize={Typography['fontsize.xs']}>
                  Status
                </UI.Text>
                <TableContentItemStatus
                  basketAdvisorStatus={{
                    isActive: true,
                    statusId: 1,
                    statusIcon: getValidatedStatusIcon(historyItem.status),
                    statusAlias: historyItem.statusAlias,
                  }}
                />
              </VStack>
            </Stack>
            <Stack w="1/4" alignItems="end">
              <HintButton
                tooltip={disabledMessage}
                variant="textLink"
                isDisabled={isDisabled}
                _text={{
                  color: 'feedback.error.default',
                  fontFamily: Typography['fontfamily.base.semibold'],
                }}
                onPress={onCancel}
                rightIcon={<UI.Icon name="Trash" size="xxxs" color="feedback.error.default" />}>
                CANCELAR
              </HintButton>
            </Stack>
          </HStack>
        </VStack>
      </Box>
    </UI.Shadow>
  );
};
